'use client';

import Image from 'next/image';
import Link from 'next/link';
import { BsCalendar2EventFill } from 'react-icons/bs';
import Button from '@src/components/atoms/button';
import { useQueryArticleBanner } from '@src/apis/article';
import { useMemo } from 'react';

// Helper to create article slug
const createArticleSlug = (article) => {
  if (!article) return '';
  const slugifiedTitle = article.title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .substring(0, 60);
  return `${article.id}-${slugifiedTitle}`;
};

const HomepageBanner = () => {
  const { data, isLoading } = useQueryArticleBanner();

  const bannerData = useMemo(() => {
    return data?.data?.data || null;
  }, [data]);

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 bg-[#F4F2EB] relative overflow-hidden h-[416px] dd2-2xl:h-[272px] dd2-xl:h-[323px] dd2-lg:h-[210px] animate-pulse" />
    );
  }

  if (!bannerData) return null;

  const articleSlug = createArticleSlug(bannerData);

  return (
    <div className="grid grid-cols-2 bg-[#F4F2EB] relative overflow-hidden 
     dd2-2xl:items-center 
     dd2-xl:block">
      <div className="py-[40px] pl-[48px] h-full relative z-10 
      dd2-xl:p-6 
      dd2-lg:p-4">
        <span className="mb-2 w-fit bg-[#FFFFFF] rounded-[2px] px-2 h-6 flex items-center justify-center text-[11px] font-satoshi-bold">
          {bannerData?.category?.name?.toUpperCase() || 'INSIGHT'}
        </span>
        <h1 className="mb-2 text-[33px] font-satoshi-bold text-[#252526] line-clamp-3 
         dd2-lg:text-[21px]">
          {bannerData?.title}
        </h1>
        <div 
          className="mb-2 text-[17px] font-satoshi text-[#252526] max-w-[536px] line-clamp-2 
         dd2-xl:hidden"
          dangerouslySetInnerHTML={{ __html: bannerData?.content_article || '' }}
        />
        <div className="flex items-center gap-2 mb-6 
        dd2-xl:mb-0">
          <BsCalendar2EventFill className="text-[#686A68]" />
          <p className="text-[14px] font-satoshi text-[#686A68]">{bannerData?.created_at}</p>
        </div>
        <Link href={`/stories/${articleSlug}`}>
          <Button 
            className="h-[32px] !px-[12px] !py-0 
          dd2-xl:hidden">Baca Selengkapnya</Button>
        </Link>
      </div>

      <div className="relative">
        <Image
          src={bannerData?.main_image}
          alt={bannerData?.title || 'Banner'}
          width={1000}
          height={1000}
          className="w-full h-[416px] object-cover 
          dd2-2xl:h-[272px] 
          dd2-xl:h-[323px]
          dd2-lg:h-[210px]"
        />
        <div 
          className="absolute top-0 -left-2 bottom-0 w-[150px] pointer-events-none 
          dd2-xl:hidden"
          style={{
            background: 'linear-gradient(90deg, #F4F2EB 0%, #F4F2EB 20%, rgba(244, 242, 235, 0.8) 50%, rgba(244, 242, 235, 0.4) 75%, rgba(244, 242, 235, 0) 100%)'
          }}
        />
      </div>
    </div>
  );
};

export default HomepageBanner;
